<template>
  <div class="bulk-asset-upload-page">
    <!--<h2 class="global-h2" style="margin-bottom: 8px">Bulk Image Upload</h2>
    <p class="global-p bulk-asset-upload-page__subtitle">Easily upload images to get started with Atlas.</p>-->

    <AtlasContentIngestionPanel :customerId="customerId" :returnTo="returnTo" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import AtlasContentIngestionPanel from "./AtlasContentIngestionPanel.vue";
import AdminContext from "@logic/AdminContext";
import { normalizeReturnTo, type BulkUploadReturnTo } from "./bulkUploadReturnTo";

defineOptions({
  name: "BulkAssetUploadPage",
});

const route = useRoute();
const customerId = computed(() => (Array.isArray(route.params.customerId) ? route.params.customerId[0] : (route.params.customerId as string)));
const returnTo = computed<BulkUploadReturnTo>(() => normalizeReturnTo(route.query.returnTo));

onMounted(async () => {
  await AdminContext.setOrgInContextFromCustomerId(customerId.value);
});
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

.bulk-asset-upload-page {
  width: $desktop-wide-right-col-width;
  margin: 0 auto;
}

@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .bulk-asset-upload-page {
    width: $desktop-right-col-width;
  }
}
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .bulk-asset-upload-page {
    width: $laptop-right-col-width;
  }
}
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .bulk-asset-upload-page {
    width: $tablet-large-content-width;
  }
}
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .bulk-asset-upload-page {
    width: $tablet-content-width;
  }
}
@media (max-width: $mobile-max-width) {
  .bulk-asset-upload-page {
    width: $mobile-content-width;
  }
}
</style>
